const DEFAULT_MAX_PASSENGERS = 4;
const DEFAULT_MAX_SUITCASE = 4;

/**
 * Max guests = vehicle seater capacity. Falls back when vehicle/fields missing.
 */
export function getBookingQuantityLimits(vehicle) {
  const seater = Number(vehicle?.seater);
  const luggage = Number(vehicle?.luggage);

  const maxPassengers =
    Number.isFinite(seater) && seater >= 1
      ? Math.max(1, seater)
      : DEFAULT_MAX_PASSENGERS;

  const maxSuitcase =
    Number.isFinite(luggage) && luggage >= 0
      ? Math.max(0, luggage)
      : DEFAULT_MAX_SUITCASE;

  return { maxPassengers, maxSuitcase };
}

export function clampQuantities({
  passengers,
  suitcase,
  maxPassengers,
  maxSuitcase,
  minPassengers = 1,
  minSuitcase = 0,
}) {
  const p = Number(passengers);
  const pVal = Number.isFinite(p) ? p : minPassengers;
  const s = Number(suitcase);
  const sVal = Number.isFinite(s) ? s : minSuitcase;

  return {
    passengers: Math.min(
      maxPassengers,
      Math.max(minPassengers, pVal),
    ),
    suitcase: Math.min(maxSuitcase, Math.max(minSuitcase, sVal)),
  };
}
